import type { PersonDetail } from '@sentra/contracts';

/**
 * The name a pass is printed with, which is the holder's FIRST name and never their surname.
 *
 * The credential domain cannot read it: it lives in the person's encrypted field values, which the
 * layer that authorised the print has already decrypted. The short reference is the fallback rather
 * than an empty string, because `printPassRequestSchema` demands a non-empty name and a record whose
 * first name is somehow absent must still be able to leave with something quotable on it.
 *
 * **It lives here rather than beside one of its callers because there are two**, and they print the
 * same sheet: a pass delivered by a registration, and one delivered by an issue or a replacement
 * from the person's own record. The second used to pass the short reference instead, which put
 * `P-000123` on the A4 sheet where a name belongs.
 */
export function firstNameOf(person: PersonDetail): string {
  const value = person.fields.first_name;
  return typeof value === 'string' && value.trim().length > 0 ? value : person.shortRef;
}
